import { type GridRowId } from "@mui/x-data-grid-pro";

// グリッドのチェック列定義。列生成（route）とチェック集計（送信節）の両方から参照する
export const CHECKBOX_FIELDS = [
  { field: "kyoutan", headerName: "共担", width: 90 },
  { field: "sintaku", headerName: "信託", width: 90 },
  { field: "genzai", headerName: "現在", width: 90 },
  { field: "requestClosureBook", headerName: "閉鎖", width: 90 },
  { field: "ownerInfo", headerName: "所有者事項", width: 100 },
  { field: "electricDrawings", headerName: "電子公図", width: 90 },
  { field: "tisekiDrawings", headerName: "地積測量図", width: 100 },
  { field: "tiekiDrawings", headerName: "地役権図面", width: 100 },
  { field: "buildingDrawings", headerName: "建物図面", width: 90 },
] as const;

export const CHECKBOX_FIELD_NAMES = CHECKBOX_FIELDS.map(({ field }) => field);

// 「全部事項」として扱う列（カラムグルーピングと解析チェックの活性判定に使う）
export const ALL_MATTERS_FIELDS = [
  "kyoutan",
  "sintaku",
  "genzai",
  "requestClosureBook",
] as const;

export const isAllMattersField = (field: string): boolean =>
  (ALL_MATTERS_FIELDS as readonly string[]).includes(field);

// 閉鎖登記簿は現在事項と併記できず、他書類との混在依頼もできない（BE は違反を 400 にする）ため、
// 閉鎖チェック中の行では共担・信託以外の列を取得できない（既存 /acquiremultiplebooks と同じ排他）
export const CLOSURE_EXCLUSIVE_FIELDS = [
  "genzai",
  "ownerInfo",
  "electricDrawings",
  "tisekiDrawings",
  "tiekiDrawings",
  "buildingDrawings",
] as const;

export const isClosureExclusiveField = (field: string): boolean =>
  (CLOSURE_EXCLUSIVE_FIELDS as readonly string[]).includes(field);

// 現在事項のみのチェックは登記の請求要件を満たさないため、共担・信託いずれかの併用を必須にする
export const hasGenzaiOnlyRow = (
  genzaiIds: Set<GridRowId>,
  sintakuIds: Set<GridRowId>,
  kyoutanIds: Set<GridRowId>
): boolean =>
  [...genzaiIds].some((id) => !sintakuIds.has(id) && !kyoutanIds.has(id));
